import type { LinkTypes } from 'fitify-ui-landing/src/@types'
import NavigationMenu, {
  NavigationVariant,
} from 'fitify-ui-landing/src/components/Navigation/NavigationMenu'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import type { ReactNode } from 'react'

import Container from '@/components/Container/Container'

import {
  StyledFooter,
  StyledFooterBrandImage,
  StyledFooterCopy,
  StyledFooterGrid,
  StyledFooterImagesColumn,
  StyledFooterMenuColumn,
  StyledFooterStoreIcons,
  StyledNavigationMenuWrapper,
} from './Footer.Styled'

interface FooterProps {
  copyLinks: LinkTypes.Navigation[]
  socialLinks: LinkTypes.Navigation[]
  navigationLinks: LinkTypes.Navigation[]
  storeLinks?: {
    name: string
    icon: ReactNode
    link: string
  }[]
  logo: ReactNode
}

const Footer = ({
  copyLinks,
  socialLinks,
  navigationLinks,
  storeLinks,
  logo,
}: FooterProps) => {
  const { t } = useTranslation()
  return (
    <StyledFooter>
      <Container>
        <StyledFooterGrid>
          <StyledFooterImagesColumn>
            <StyledFooterBrandImage
              href="/"
              aria-label={t('cl_aria_label_go_to_homepage')}
            >
              {logo}
            </StyledFooterBrandImage>
            {storeLinks && storeLinks.length > 0 ? (
              <StyledFooterStoreIcons>
                {storeLinks.map((storeLink, index: number) => (
                  <Link
                    key={index}
                    href={storeLink.link}
                    target={'_blank'}
                    rel="noreferrer"
                    aria-label={storeLink.name}
                  >
                    {storeLink.icon}
                  </Link>
                ))}
              </StyledFooterStoreIcons>
            ) : null}
          </StyledFooterImagesColumn>

          <StyledFooterMenuColumn>
            <NavigationMenu
              items={navigationLinks}
              variant={NavigationVariant.FOOTER}
            />

            <NavigationMenu
              items={socialLinks}
              variant={NavigationVariant.FOOTER}
            />
          </StyledFooterMenuColumn>
        </StyledFooterGrid>

        <StyledFooterCopy>
          <StyledNavigationMenuWrapper>
            <NavigationMenu
              items={copyLinks}
              variant={NavigationVariant.COPY_WHITE}
            />
          </StyledNavigationMenuWrapper>
        </StyledFooterCopy>
      </Container>
    </StyledFooter>
  )
}

export default Footer
